import React from 'react';
import { Link } from 'react-router-dom';

const PartnerBrands: React.FC = () => {
  // Brand logos array - in a real implementation, these would be images from your assets
  const brandLogos = [
    { src: require("../../assets/images/partnerlogo1.png"), alt: "partnerlogo1" },
    { src: require("../../assets/images/partnerlogo2.png"), alt: "partnerlogo2" },
    { src: require("../../assets/images/partnerlogo3.png"), alt: "partnerlogo3" },
    { src: require("../../assets/images/partnerlogo4.png"), alt: "partnerlogo4" },
    { src: require("../../assets/images/partnerlogo5.png"), alt: "partnerlogo5" },
    { src: require("../../assets/images/partnerlogo6.png"), alt: "partnerlogo6" },
    { src: require("../../assets/images/partnerlogo7.png"), alt: "partnerlogo7" },
    { src: require("../../assets/images/partnerlogo8.png"), alt: "partnerlogo8" },
    { src: require("../../assets/images/partnerlogo9.png"), alt: "partnerlogo9" },
    { src: require("../../assets/images/partnerlogo10.png"), alt: "partnerlogo10" },
    { src: require("../../assets/images/partnerlogo11.png"), alt: "partnerlogo11" },
    { src: require("../../assets/images/partnerlogo12.png"), alt: "partnerlogo12" },
    { src: require("../../assets/images/partnerlogo13.png"), alt: "partnerlogo13" },
    { src: require("../../assets/images/partnerlogo14.png"), alt: "partnerlogo14" },
    { src: require("../../assets/images/partnerlogo15.png"), alt: "partnerlogo15" },
    { src: require("../../assets/images/partnerlogo16.png"), alt: "partnerlogo16" },
    { src: require("../../assets/images/partnerlogo17.png"), alt: "partnerlogo17" },
    { src: require("../../assets/images/partnerlogo18.png"), alt: "partnerlogo18" },
    { src: require("../../assets/images/partnerlogo19.png"), alt: "partnerlogo19" },
    { src: require("../../assets/images/partnerlogo20.png"), alt: "partnerlogo20" },
    { src: require("../../assets/images/partnerlogo21.png"), alt: "partnerlogo21" },
    { src: require("../../assets/images/partnerlogo22.png"), alt: "partnerlogo22" }
  ];

  // Create a larger array with repeated logos for dense background
  const generateBackgroundLogos = () => {
    const repeatedLogos = [];
    // Create a larger array with repeated logos in random order
    for (let i = 0; i < 100; i++) {
      const randomIndex = Math.floor(Math.random() * brandLogos.length);
      repeatedLogos.push(brandLogos[randomIndex]);
    }
    return repeatedLogos;
  };

  const backgroundLogos = generateBackgroundLogos();

  return (
    <section className="bg-dark py-20 px-4 relative overflow-hidden">
      {/* Semi-circular background effect */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gray-800 rounded-full scale-[1.8] translate-y-[40%] opacity-10"></div>
      </div>
      
      {/* Dense brand logos background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 grid grid-cols-8 md:grid-cols-12 gap-2 p-4 opacity-20">
          {backgroundLogos.map((brand, index) => (
            <div 
              key={index}
              className="flex items-center justify-center"
              style={{
                transform: `rotate(${Math.random() * 20 - 10}deg) scale(${0.7 + Math.random() * 0.5})`,
                position: 'relative',
                top: `${Math.random() * 30 - 15}px`,
                left: `${Math.random() * 30 - 15}px`,
              }}
            >
              <div className="w-16 h-16 bg-white rounded-full overflow-hidden">
                <img 
                  src={brand.src} 
                  alt={brand.alt} 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="max-w-6xl mx-auto relative z-10">
      <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center bg-dark-light px-4 py-2 rounded-md mb-8">
            <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
            </svg>
            <span className="text-white text-xl tracking-wider">Partner Brands</span>
          </div>
        </div>

        {/* Main content - without background and images */}
        <div className="relative">
          <div className="max-w-2xl mx-auto backdrop-blur-md rounded-3xl p-10">
            <div className="text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-300 mb-2">
                Shop Confidently with
              </h2>
              <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-400 mb-6">
                India's Favorite Brands
              </h2>
              
              <p className="text-center text-gray-400 mb-8 max-w-3xl mx-auto">
                Get refunds, discounts, and exclusive perks at your favorite stores
              </p>

              <div className="text-center mt-8">
                <Link 
                  to="/partner-brands" 
                  className="inline-block bg-dark-light hover:bg-dark-lighter border border-gray-800 text-white px-6 py-3 rounded-full font-medium transition"
                >
                  See All Partner Brands
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerBrands;